
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing-page/[slug]",
      function () {
        return require("private-next-pages/landing-page/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing-page/[slug]"])
      });
    }
  